/* eslint-disable */
export default {
  flipHeader: '通話のフリップ先...',
  flip: 'フリップ',
  complete: 'フリップの完了',
} as const;

// @key: @#@"flipHeader"@#@ @source: @#@"Flip Call to..."@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"complete"@#@ @source: @#@"Complete Flip"@#@
